export default {
    MILLIMETERS: 'mm',
    PIXELS: 'px'
}